import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/articles/ArticleClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/articles/ArticleDetailClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/endowment/EndowmentForm.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/endowment/EndowmentHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/contact/Contact.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/newsletter/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/testimonies/Testimonies.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/video/video.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/Home/features/features.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/hero.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/president.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/values.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/aboutpage1.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/bottomleft.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/bottomright.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/featuresimg.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/president_new.jpg");
